import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';

/**
 * This hook is meant to be used in conjuction with a SearchableSelect or something similiar.
 * It will provide all the bindings for the view, and a fallback if the desired entity was not found
 */
export function useSelectEntityItems(t0) {
  const $ = _c(21);
  const {
    value,
    entities,
    entityNotFoundText,
    getDisplayTextOfEntity,
    getKeyOfEntity,
    onValueChanged,
    getValueOfEntity
  } = t0;
  let t1;
  if ($[0] !== entities) {
    t1 = {
      entities
    };
    $[0] = entities;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = useItems(t1);
  let t2;
  if ($[2] !== getValueOfEntity || $[3] !== items || $[4] !== value) {
    t2 = {
      value,
      items,
      getValueOfEntity
    };
    $[2] = getValueOfEntity;
    $[3] = items;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = useSelectedItem(t2);
  let t4;
  if ($[6] !== entityNotFoundText || $[7] !== getDisplayTextOfEntity) {
    t4 = {
      entityNotFoundText,
      getDisplayTextOfEntity
    };
    $[6] = entityNotFoundText;
    $[7] = getDisplayTextOfEntity;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = useGetDisplayTextOfItem(t4);
  let t6;
  if ($[9] !== getKeyOfEntity) {
    t6 = {
      getKeyOfEntity
    };
    $[9] = getKeyOfEntity;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = useGetKeyOfItem(t6);
  let t8;
  if ($[11] !== getValueOfEntity || $[12] !== onValueChanged || $[13] !== value) {
    t8 = {
      value,
      onValueChanged,
      getValueOfEntity
    };
    $[11] = getValueOfEntity;
    $[12] = onValueChanged;
    $[13] = value;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = useOnSelectedItemChanged(t8);
  let t10;
  if ($[15] !== items || $[16] !== t3 || $[17] !== t5 || $[18] !== t7 || $[19] !== t9) {
    t10 = {
      items,
      selectedItem: t3,
      getDisplayTextOfItem: t5,
      getKeyOfItem: t7,
      onSelectedItemChanged: t9
    };
    $[15] = items;
    $[16] = t3;
    $[17] = t5;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function useItems(t0) {
  const $ = _c(2);
  const {
    entities
  } = t0;
  let t1;
  if ($[0] !== entities) {
    t1 = entities.map(_temp);
    $[0] = entities;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(entity) {
  return {
    type: SelectEntityItemType.Entity,
    entity
  };
}
function useSelectedItem(t0) {
  const $ = _c(8);
  const {
    value,
    items,
    getValueOfEntity
  } = t0;
  let t1;
  bb0: {
    let t2;
    if ($[0] !== getValueOfEntity || $[1] !== items || $[2] !== value) {
      let t3;
      if ($[4] !== getValueOfEntity || $[5] !== value) {
        t3 = item => item.type === SelectEntityItemType.Entity && getValueOfEntity(item.entity) === value;
        $[4] = getValueOfEntity;
        $[5] = value;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      t2 = items.find(t3);
      $[0] = getValueOfEntity;
      $[1] = items;
      $[2] = value;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const existingItem = t2;
    if (existingItem) {
      t1 = existingItem;
      break bb0;
    }
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        type: SelectEntityItemType.EntityNotFound
      };
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t1 = t3;
  }
  return t1;
}
function useGetDisplayTextOfItem(t0) {
  const $ = _c(3);
  const {
    entityNotFoundText,
    getDisplayTextOfEntity
  } = t0;
  let t1;
  if ($[0] !== entityNotFoundText || $[1] !== getDisplayTextOfEntity) {
    t1 = item => handleItem({
      item,
      handleEntity: getDisplayTextOfEntity,
      handleNotFound: () => entityNotFoundText
    });
    $[0] = entityNotFoundText;
    $[1] = getDisplayTextOfEntity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function useGetKeyOfItem(t0) {
  const $ = _c(2);
  const {
    getKeyOfEntity
  } = t0;
  let t1;
  if ($[0] !== getKeyOfEntity) {
    t1 = item => handleItem({
      item,
      handleEntity: getKeyOfEntity,
      handleNotFound: _temp2
    });
    $[0] = getKeyOfEntity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp2() {
  return "useSelectEntityItems.entityNotFound";
}
function useOnSelectedItemChanged(t0) {
  const $ = _c(4);
  const {
    onValueChanged,
    value,
    getValueOfEntity
  } = t0;
  let t1;
  if ($[0] !== getValueOfEntity || $[1] !== onValueChanged || $[2] !== value) {
    t1 = item => {
      if (item.type === SelectEntityItemType.EntityNotFound) {
        throw new Error("a entity not found item should not be selectable");
      }
      const newValue = getValueOfEntity(item.entity);
      if (newValue !== value) {
        onValueChanged(newValue);
      }
    };
    $[0] = getValueOfEntity;
    $[1] = onValueChanged;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useEventCallback(t1);
}
function handleItem<TEntity, TReturnValue>({
  item,
  handleNotFound,
  handleEntity
}: {
  item: SelectEntityItem<TEntity>;
  handleNotFound: () => TReturnValue;
  handleEntity: (entity: TEntity) => TReturnValue;
}): TReturnValue {
  switch (item.type) {
    case SelectEntityItemType.Entity:
      return handleEntity(item.entity);
    case SelectEntityItemType.EntityNotFound:
      return handleNotFound();
    default:
      throw new Error(`item type "${(item as SelectEntityItem<TEntity>).type}" is not handled`);
  }
}
export type UseSelectEntityItemsOptions<TEntity, TValue> = {
  value: TValue;
  entities: Array<TEntity>;
  entityNotFoundText: string;
  onValueChanged: (value: TValue) => void;
  getDisplayTextOfEntity: GetDisplayTextOfEntity<TEntity>;
  getKeyOfEntity: GetKeyOfEntity<TEntity>;
  getValueOfEntity: GetValueOfEntity<TEntity, TValue>;
};
export type UseSelectEntityItemsReturnValue<TEntity> = {
  items: Array<SelectEntityItem<TEntity>>;
  selectedItem: SelectEntityItem<TEntity>;
  getDisplayTextOfItem: (item: SelectEntityItem<TEntity>) => string;
  getKeyOfItem: (item: SelectEntityItem<TEntity>) => string;
  onSelectedItemChanged: (item: SelectEntityItem<TEntity>) => void;
};
export type GetValueOfEntity<TEntity, TValue> = (entity: TEntity) => TValue;
export type GetDisplayTextOfEntity<TEntity> = (entity: TEntity) => string;
export type GetKeyOfEntity<TEntity> = (entity: TEntity) => string;
export enum SelectEntityItemType {
  Entity = 'entity',
  EntityNotFound = 'entityNotFound',
}
type BaseSelectEntityItem<TType extends SelectEntityItemType> = {
  type: TType;
};
export type SelectEntityEntityItem<TEntity> = BaseSelectEntityItem<SelectEntityItemType.Entity> & {
  entity: TEntity;
};
export type SelectEntityEntityNotFoundItem = BaseSelectEntityItem<SelectEntityItemType.EntityNotFound>;
export type SelectEntityItem<TEntity> = SelectEntityEntityNotFoundItem | SelectEntityEntityItem<TEntity>;